import { render, staticRenderFns } from "./TermsandCondition.vue?vue&type=template&id=bf0838c2"
import script from "./TermsandCondition.vue?vue&type=script&lang=js"
export * from "./TermsandCondition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports